import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import HeaderV2 from '../components/HeaderV2';
import FooterV2 from '../components/FooterV2';
import FunctionalHeroV2 from '../components/FunctionalHeroV2';
import SystemUpdate2026QPage from './SystemUpdate2026QPage';

/**
 * SystemUpdate2026QV2Page
 * Barista Map 風格 V2 殼：HeaderV2 + 壓縮 Hero + 奶油色功能區 + FooterV2
 * 對應路由：/zh/system-update-2026Q/v2
 * 內部頁；/v2 預覽下殼輸出 noindex,nofollow + canonical，正式 URL 上由內嵌頁接管。
 */
export default function SystemUpdate2026QV2Page() {
  const location = useLocation();
  const isPreviewRoute = location.pathname.includes('/v2');
  const canonicalUrl = `https://www.ongucoffee.com/zh/system-update-2026Q`;

  useEffect(() => {
    const fontId = 'v2-fonts-system-update';
    if (!document.getElementById(fontId)) {
      const link = document.createElement('link');
      link.id = fontId;
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;1,400&family=Noto+Serif+TC:wght@300;400;500&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  return (
    <>
      {isPreviewRoute && (
        <Helmet>
          <meta name="robots" content="noindex,nofollow" />
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
      )}
      <div className="min-h-screen bg-[#f5f1ea]">
        <HeaderV2 />
        <FunctionalHeroV2
          eyebrow="Internal / 系統路線圖"
          title="2026Q 系統更新"
          subtitle="ONGU 系統 2026 年度模組更新與 Checklist 追蹤進度"
          backgroundImage="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1920"
          breadcrumbs={[
            { label: '首頁', to: '/zh' },
            { label: 'Internal' },
            { label: '2026Q 系統更新' },
          ]}
        />
        <main
          className="bg-[#f5f1ea]"
          style={{ fontFamily: "'EB Garamond', 'Noto Serif TC', serif" }}
        >
          <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-12 md:py-16">
            <SystemUpdate2026QPage />
          </div>
        </main>
        <FooterV2 />
      </div>
    </>
  );
}
